
import { useTranslation } from 'react-i18next';

const ListaNoticias = ({ lang, noticias, ruta, config }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";
    return (
        <>
            <section className="u-clearfix u-section-1" id="block-10">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-md u-valign-middle-sm u-valign-middle-xl u-sheet-1">
                    <h2 className="u-align-center u-text u-text-body-color u-text-1" data-animation-name="customAnimationIn" data-animation-duration="1500" data-animation-out="0"> {t("Déjate inspirar")}</h2>
                    <p className="u-align-center u-text u-text-body-color u-text-2" data-animation-name="customAnimationIn" data-animation-duration="1500" data-animation-delay="250" data-animation-out="0"> {t("Historias y rutas que inspiran tu próxima aventura en el mar")}</p>
                </div>
            </section>
            <section className="u-clearfix u-white u-section-2" id="sec-1929">
                <div className="u-clearfix u-sheet u-sheet-1">
                    <div className="u-expanded-width u-list u-list-1">
                        <div className="u-repeater u-repeater-1">
                            {
                                noticias.map((unanoticia, index) => (
                                    <div className="u-align-center u-container-align-center u-container-align-center-lg u-container-align-center-md u-container-align-center-sm u-container-align-center-xl u-container-style u-list-item u-radius u-repeater-item u-shape-round u-white u-list-item-1" data-animation-name="customAnimationIn" data-animation-direction="Up" data-animation-duration="1500" data-animation-delay="500" data-animation-out="0" key={index}>
                                        <div className="u-container-layout u-similar-container u-valign-top-lg u-valign-top-md u-valign-top-sm u-valign-top-xl u-container-layout-1">
                                            <img alt="" className="custom-expanded u-expanded-width-lg u-expanded-width-md u-expanded-width-sm u-expanded-width-xl u-image u-image-round u-radius u-image-1" src={unanoticia.imagen ? ruta + "/blog/" + unanoticia.id + "/" + unanoticia.imagen : "/images/web/bedloop-nofoto.png"} data-image-width="2062" data-image-height="1374" />
                                            <h5 className="u-align-center u-text u-text-black u-text-default u-text-1">{unanoticia.eltitulo}</h5>
                                            <p className="u-align-center u-text u-text-grey-50 u-text-2">{unanoticia.elsubtitulo}</p>
                                            <a href={"/" + preidioma + t("blog") + "/" + unanoticia.laurl} className="u-active-none u-align-center u-border-1 u-border-active-grey-60 u-border-black u-border-hover-grey-60 u-border-no-left u-border-no-right u-border-no-top u-btn u-button-style u-hover-feature u-hover-none u-none u-text-body-color u-btn-1" title={unanoticia.eltitulo} target="_blank">{t("MAS")} </a>
                                        </div>
                                    </div>
                                ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className="u-clearfix u-section-3" id="block-11">
                <div className="u-clearfix u-sheet u-sheet-1"></div>
            </section>

            <section className="u-clearfix u-image u-section-4" id="block-1" data-image-width="910" data-image-height="1366">
                <div className="u-clearfix u-sheet u-sheet-1">
                    <p className="u-align-center u-custom-font u-font-montserrat u-text u-text-white u-text-1"> {t("Creemos que cada travesía empieza con una idea. Inspírate y comparte con nosotros tu próxima aventura.")}</p>
                    <a href="https://www.tripadvisor.com/UserReviewEdit-g187463-d33374501-On_Board_Holidays-Palma_de_Mallorca_Majorca_Balearic_Islands.html" className="u-align-center u-border-2 u-border-custom-color-5 u-border-hover-custom-color-5 u-btn u-btn-round u-button-style u-hover-grey-5 u-radius u-text-custom-color-5 u-white u-btn-1">{t("Cuéntanos tu experiencia")} </a>
                </div>
            </section>

        </>
    );
}

export default ListaNoticias;
